export const environment = {
    production: false,
    apiUrl: 'https://uat.api.p-gate.process-gate-systems.com',
    logoPath: '/assets/images/logo_zollern.png',
    featureFlags: {
        qualification: { enabled: false, visible: false },
        audit: { enabled: false, visible: false },
        calibration: { enabled: false, visible: false },
        inspectionLog: { enabled: false, visible: false },
        maintenance: { enabled: false, visible: false },
        pmc: { enabled: true, visible: true },
        stampControl: { enabled: false, visible: false },
        equipment: { enabled: true, visible: true },
        document: { enabled: false, visible: false },
    },
    keycloak: {
        url: 'https://uat.auth.process-gate-systems.com',
        realm: 'process-gate-systems-uat',
        clientId: 'p-gate-uat'
    }
};
